
import {css, html, LitElement} from 'lit'
import {TableFilterSectionBase} from 'shared/tables/table-filter-section-base.component'
import {Assets} from 'shared/assets'
import {graphQL} from '../graphQL'


class TableFilterGroups extends TableFilterSectionBase {
  static styles = [
    TableFilterSectionBase.styles,
    css`
      header svg {
        position: relative;
        top: 2px;
      }
    `];

  static properties = {
    data: {state: true},
  };


  constructor() {
    super()
    this.valueType = 'array'
    this.data = []
  }


  connectedCallback() {
    super.connectedCallback()
    graphQL.ready(() => this.getData())
  }


  getData() {
    let query = `
      query {
        groups(filters: {forOrganizationId: ${graphQL.organizationId()}, forAccountId: ${graphQL.accountId()}})
        {
          id
          name
        }
      }
    `;

    graphQL.query({
      query: query,
      success: (response) => {
        this.data = response.data.groups
      },
      error: (message) => {
        console.log(`Error in filter while getting Groups: ${message}`)
      },
    });
  }


  render() {
    let items = []
    for (const type of this.data) {
      items.push(this.itemHelper(type.name, type.id, html`
        ${type.name}
      `))
    }

    return html`
      ${this.sectionHelper(html`
        ${Assets.inlineSvg('filters/groups.svg')}&nbsp;Groups`, items)}
    `;
  }
}
customElements.define('table-filter-groups', TableFilterGroups);

